import { render, staticRenderFns } from "./SocialSeriesCustomFields.vue?vue&type=template&id=2267115b&scoped=true&"
import script from "./SocialSeriesCustomFields.vue?vue&type=script&lang=js&"
export * from "./SocialSeriesCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./SocialSeriesCustomFields.vue?vue&type=style&index=0&id=2267115b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267115b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2267115b')) {
      api.createRecord('2267115b', component.options)
    } else {
      api.reload('2267115b', component.options)
    }
    module.hot.accept("./SocialSeriesCustomFields.vue?vue&type=template&id=2267115b&scoped=true&", function () {
      api.rerender('2267115b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialSeriesCustomFields.vue"
export default component.exports